import { motion } from "framer-motion";
import { Star } from "lucide-react";

export const Testimonial = ({ t }) => (
  <section id="kundenstimmen" className="bg-ink text-cream py-24 md:py-36" data-testid="testimonial-section">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <motion.p
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="text-xs uppercase tracking-[0.25em] font-bold text-cream/60 mb-4 text-center"
        data-testid="testimonial-overline"
      >
        {t.testimonials.overline}
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        className="flex justify-center gap-1.5 mb-16"
        data-testid="testimonial-stars"
      >
        {[...Array(5)].map((_, i) => (
          <Star key={i} size={18} strokeWidth={1} className="fill-taupe text-taupe" />
        ))}
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
        {t.testimonials.items.map((item, i) => (
          <motion.figure
            key={i}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col border-t border-cream/20 pt-8"
            data-testid={`testimonial-${i + 1}`}
          >
            <blockquote className="font-heading font-light italic text-xl md:text-2xl leading-[1.35] flex-1" data-testid={`testimonial-quote-${i + 1}`}>
              {item.quote}
            </blockquote>
            <figcaption className="mt-8 flex items-center gap-4">
              <span className="w-11 h-11 rounded-full border border-taupe/50 flex items-center justify-center font-heading text-taupe text-sm shrink-0">
                {item.author.charAt(0)}
              </span>
              <span>
                <span className="block font-semibold text-sm tracking-wide" data-testid={`testimonial-author-${i + 1}`}>{item.author}</span>
                <span className="block text-cream/55 text-xs mt-0.5 tracking-wide">{item.role}</span>
              </span>
            </figcaption>
          </motion.figure>
        ))}
      </div>

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, delay: 0.3 }}
        className="mt-14 text-center text-cream/40 text-xs tracking-wide"
        data-testid="testimonial-note"
      >
        {t.testimonials.note}
      </motion.p>
    </div>
  </section>
);
